/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustments_Card_DescriptionInputs */

const en_shipping_adjustments_card_description = /** @type {(inputs: Shipping_Adjustments_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and manage shipping charge corrections.`)
};

const es_shipping_adjustments_card_description = /** @type {(inputs: Shipping_Adjustments_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver y administrar correcciones de cargos de envio.`)
};

/**
* | output |
* | --- |
* | "View and manage shipping charge corrections." |
*
* @param {Shipping_Adjustments_Card_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustments_card_description = /** @type {((inputs?: Shipping_Adjustments_Card_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustments_Card_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustments_card_description(inputs)
	return es_shipping_adjustments_card_description(inputs)
});